import {
  Phone,
  Mail,
  MapPin,
  Facebook,

  Instagram,
  Linkedin,
} from "lucide-react";
import { Link } from "react-router-dom";
import { ChevronUp } from "lucide-react";

export default function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="w-full bg-[#000000] text-white">
      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-20 right-4 z-50 bg-[#d3ac88] text-white p-2 rounded-full shadow-lg hover:bg-[#c09d75] transition duration-300"
        aria-label="Scroll to top"
      >
        <ChevronUp size={20} />
      </button>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919112474911?text=Hello%21%20I%E2%80%99m%20interested%20in%20Nirmita%20International%E2%80%99s%20premium%20export%20products%20such%20as%20Organic%20Fertilizers%2C%20Herbal%20Products%2C%20Bagasse%20Tableware%2C%20and%20Cocopeat%2FCoir.%20Please%20share%20more%20details.%20Thank%20you%21"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 z-50 bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg transition duration-300 flex items-center gap-2 animate-bounce"
        aria-label="Chat on WhatsApp"
      >
        {/* Contact Us Text */}
        <span className="hidden sm:inline font-semibold text-white">
          Contact Us
        </span>

        {/* WhatsApp Icon */}
        <img
          src="https://img.icons8.com/ios-filled/24/ffffff/whatsapp.png"
          alt="WhatsApp"
          className="w-6 h-6"
        />
      </a>

      <div className="max-w-7xl mx-auto py-12 px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 left-align-center">
          {/* Logo and About */}
          <div className="flex flex-col items-center md:items-start space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src={require("../assets/logoNI.png")}
                alt="Nirmita International Logo"
                width={160}
                height={160}
                className="object-contain"
              />
            </div>

            {/* Government registration info BELOW logo */}
            {/* <div className="mt-4 text-center md:text-left text-sm text-gray-300 whitespace-pre-line max-w-xs">
              Government of India Registered Exporter<br />
              IEC CODE: KVMPS4973R<br />
              GST: 27KVMPS4973R1ZZ<br />
              UDYAM ADHAR: UDYAM-MH-03-0070499
            </div> */}
          </div>

          {/* Quick Links */}
          <div className="space-y-2 text-left">
            <h3 className="text-lg font-medium mb-4">QUICK LINKS</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  onClick={scrollToTop}
                  className="text-sm text-gray-300 hover:text-white"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/aboutus"
                  onClick={scrollToTop}
                  className="text-sm text-gray-300 hover:text-white"
                >
                  About Us
                </Link>
              </li>
              {/* <li>
                <Link to="/collection" onClick={scrollToTop} className="text-sm text-gray-300 hover:text-white">
                  Collection
                </Link>
              </li> */}
              <li>
                <Link
                  to="/certificates"
                  onClick={scrollToTop}
                  className="text-sm text-gray-300 hover:text-white"
                >
                  Certificates
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div className="space-y-2 text-left">
            <h3 className="text-lg font-medium mb-4">HELP</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/contact-us"
                  onClick={scrollToTop}
                  className="text-sm text-gray-300 hover:text-white"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/privacyPolicy"
                  onClick={scrollToTop}
                  className="text-sm text-gray-300 hover:text-white"
                >
                  Privacy policy
                </Link>
              </li>
              <li>
                <Link
                  to="/termsofService"
                  onClick={scrollToTop}
                  className="text-sm text-gray-300 hover:text-white"
                >
                  Terms of service.
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div className="space-y-3 text-left">
            <h3 className="text-lg font-medium mb-4">CONTACT US</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin size={18} className="flex-shrink-0 mt-1" />
                <span className="text-sm text-gray-300">
                 Pune, Maharashtra, India
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={18} />
                <a
                  href="tel:+919112474911"
                  className="text-sm text-gray-300 hover:underline"
                >
                  +91 9112474911
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={18} />
                <a
                  href="mailto:info@nirmitainternational.com"
                  className="text-sm text-gray-300 hover:underline"
                >
                  info@nirmitainternational.com
                </a>
              </li>
            </ul>

            <div className="flex justify-start space-x-4 mt-4">
              <div className="flex justify-start space-x-4 mt-4">
                <a
                  href="https://www.facebook.com/profile.php?id=61579068592688"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <Facebook
                    size={20}
                    className="text-gray-300 hover:text-white"
                  />
                </a>
                <a
                  href="https://www.instagram.com/nirmita_international/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <Instagram
                    size={20}
                    className="text-gray-300 hover:text-white"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/nirmita-international/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Linkedin"
                >
                  <Linkedin
                    size={20}
                    className="text-gray-300 hover:text-white"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-sm text-[#FFFFFF]">
          <p>
            Copyright © All rights reserved | Nirmita International | Developed
            by{" "}
            <a
              href="https://swarajyadigital.com/"
              className="text-[#d3ac88] hover:text-white underline"
            >
              Swarajya Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
